import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from '../services/http.service';
import { IRole } from './role.model';
import { createRequestOption, SearchWithPagination } from '@cupoui/shared/util/request-util';
import { ISystemRoleDescription } from '@cupoui/core/user/systemrole-description.model';
import { PermissionType } from '@cupoui/core/user/permission-type';

@Injectable({ providedIn: 'root' })
export class RoleService {
  public resourceUrl = '/services/cupo-user-administration/api/customer-roles';
  public resourceQueryUrl = '/services/cupo-user-administration/api/customer-roles/by-query';

  constructor(private httpService: HttpService, private http: HttpClient) {
  }

  create(role: IRole): Observable<IRole> {
    return this.httpService.post<IRole>(this.resourceUrl, role);
  }

  update(role: IRole): Observable<IRole> {
    return this.httpService.put<IRole>(this.resourceUrl, role);
  }

  delete(roleId: string): Observable<{}> {
    return this.httpService.delete(`${this.resourceUrl}/${roleId}`);
  }

  customerRoles(type: PermissionType): Observable<IRole[]> {
    return this.httpService.get<IRole[]>(this.resourceUrl, { params: { type } });
  }

  myCustomerRoles(): Observable<IRole[]> {
    return this.httpService.get<IRole[]>(this.resourceUrl + '/mine');
  }

  query(req?: SearchWithPagination): Observable<HttpResponse<IRole[]>> {
    const options = createRequestOption(req);
    return this.http.get<IRole[]>(this.resourceQueryUrl, { params: options, observe: 'response' });
  }

  findCaseEventEligibleRoles(): Observable<ISystemRoleDescription[]> {
    return this.httpService.get<ISystemRoleDescription[]>(this.resourceUrl + '/find-case-event-eligible');
  }
}
